import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from 'components/Button';
import { getText } from 'helpers/i18n';
import './clickCollectSubmit.styles.scss';

export default class ClickCollectSubmit extends Component {
    onSubmit = () => {
        const { selectedStore, products, placeCollectOrder } = this.props;

        placeCollectOrder(selectedStore, products);
    }

    onSubmitWrapper = () => {
        const { onBeforeSubmit } = this.props;
        if (onBeforeSubmit)  {
            onBeforeSubmit(this.onSubmit);
        } else {
            this.onSubmit();
        }
    }

    render() {
        const { noStoresAvailable, selectedStore, products } = this.props;

        const noProductsAvailable = products ? Object.keys(products).length === 0 : true;

        if (!window.Checkout.settings.clickcollect.enable_on_shoppinglist || noStoresAvailable || noProductsAvailable) {
            return null;
        }

        return (
            <Button
                theme="primary"
                type="submit"
                text="clickcollect_buy_button"
                className="clickcollect__buy"
                ariaLabel={getText('clickcollect_buy_button')}
                onClick={this.onSubmitWrapper}
                disabled={!selectedStore}
                isLoading={this.props.processing}
            />
        );
    }
}

ClickCollectSubmit.propTypes = {
    noStoresAvailable: PropTypes.bool.isRequired,
    selectedStore: PropTypes.oneOfType([ PropTypes.string, PropTypes.bool ]).isRequired,
    products: PropTypes.object.isRequired,
    placeCollectOrder: PropTypes.func.isRequired,
    error: PropTypes.any,
    processing: PropTypes.bool,
    onBeforeSubmit: PropTypes.func,
};
